import type { OrderAssistFaqsDefaultFirst } from 'types/assist/orderAssistFaqsDefaultFirst';

export const orderAssistFaqsDefaultFirst: OrderAssistFaqsDefaultFirst = ({
  faqs,
  defaultFaqQuestions,
}) => {
  const defaultQuestionOrder = new Map<string, number>(
    defaultFaqQuestions.map((question, questionIndex) => [question, questionIndex]),
  );

  return [...faqs].sort((firstFaq, secondFaq) => {
    const firstQuestionIndex = defaultQuestionOrder.get(firstFaq.question);
    const secondQuestionIndex = defaultQuestionOrder.get(secondFaq.question);
    const isFirstQuestionDefault = firstQuestionIndex !== undefined;
    const isSecondQuestionDefault = secondQuestionIndex !== undefined;

    if (isFirstQuestionDefault && isSecondQuestionDefault) {
      return firstQuestionIndex - secondQuestionIndex;
    }

    if (isFirstQuestionDefault) {
      return -1;
    }

    if (isSecondQuestionDefault) {
      return 1;
    }

    return 0;
  });
};
